import React, { SetStateAction, useState } from 'react';

import { Button, Form } from 'react-bootstrap';

// import {FileType} from "../../dwelling/reducers"
import { cat } from './SupportComponent';

const NewTicketForm = (_props: any) => {
  const [validateTicket, setValidateTicket] = useState(false);

  const [formSubject, setFormSubject] = useState('');
  const [formCat, setFormCat] = useState(0);
  const [formContent, setFormContent] = useState('');

  // const [files, setFiles] = useState<Array<FileType>>([])

  const addFile = () => {
    // let lastId = 1
    // if (files.length !== 0) lastId = files.length + 1
    // setFiles(files => [...files, {id: lastId, type: "invoice"}])
  };

  const handleTicketCreation = (event: any) => {
    setValidateTicket(true);
    const form = event.currentTarget;

    if (form.checkValidity() === false) {
      event.preventDefault();
      event.stopPropagation();
      return;
    }
    //Send to back-end
  };

  return (
    <Form noValidate validated={validateTicket} onSubmit={handleTicketCreation}>
      <div className="d-flex flex-row justify-content-start flex-wrap gap-1">
        <Form.Group controlId="cat" className="w-25">
          <Form.Select
            value={formCat}
            onChange={(e) => setFormCat(e.currentTarget.value as unknown as SetStateAction<number>)}
          >
            {cat.map((value, index) => {
              return (
                <option key={index} value={index}>
                  {value}
                </option>
              );
            })}
          </Form.Select>
        </Form.Group>
        <Form.Group controlId="subject" className="flex-grow-1">
          <Form.Control
            type="text"
            placeholder="Sujet du ticket"
            value={formSubject}
            onChange={(e) => setFormSubject(e.target.value)}
            required
          />
        </Form.Group>
      </div>
      <Form.Group controlId="content" className="mt-2">
        <Form.Control
          type="text"
          as="textarea"
          className="add-prop-textarea"
          placeholder="Contenu du ticket..."
          value={formContent}
          onChange={(e) => setFormContent(e.target.value)}
          required
        />
      </Form.Group>
      <div className="mt-2 bg-container pb-2 pt-1">
        {/*{files.length !== 0 && files.map((file, index) => {*/}
        {/*    return <ImportFile key={index} index={index} files={files} setFiles={setFiles}/>*/}
        {/*})}*/}
        <Button variant="info" className="d-flex mt-2 mb-0" onClick={addFile}>
          <p className="m-0 me-2" style={{ lineHeight: '18px' }}>
            +
          </p>
          Ajouter un document
        </Button>
      </div>
      <Button className="mt-2 mb-2" variant="primary" type="submit">
        Envoyer le ticket
      </Button>
    </Form>
  );
};

export default NewTicketForm;
